import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './TagPicker.css';

// Generic multi-select chip picker: partner categories or agency specialties.
const TagPicker = ({ options, selected, max, onToggle }) => (
    <div className={css.grid}>
        {options.map(option => {
            const isSelected = selected.includes(option);
            const isMaxed = !isSelected && selected.length >= max;
            return (
                <button
                    key={option}
                    type="button"
                    className={classNames(css.chip, {
                        [css.chipSelected]: isSelected,
                        [css.chipDisabled]: isMaxed,
                    })}
                    onClick={() => onToggle(option)}
                    disabled={isMaxed}
                >
                    <span className={css.checkbox}>{isSelected && <span className={css.checkmark} />}</span>
                    {option}
                </button>
            );
        })}
    </div>
);

TagPicker.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    max: PropTypes.number.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default TagPicker;
